<template>
  <div>
    <TextFormGroup
        :value="value.ad_client"
        name="ad_client"
        label="Ad Client"
        :error="(errors.ad_client || [])[0]"
        @input="emit('ad_client', $event)"
    />
    <TextFormGroup
        :value="value.ad_slot"
        name="ad_slot"
        label="Ad Slot"
        :error="(errors.ad_slot || [])[0]"
        @input="emit('ad_slot', $event)"
    />
  </div>
</template>

<script>
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
